import { getIntl } from "@umijs/max";
import type { TOptions } from "./interface";
import { capitalizeFirstWord, capitalizeEveryWord } from "./utils";

// 处理大小写转换
const handleTextCase = (text: string, caseType: string): string => {
  switch (caseType) {
    case "lower":
      return text.toLowerCase();
    case "upper":
      return text.toUpperCase();
    case "capitalizeFirst":
      return capitalizeFirstWord(text);
    case "capitalizeEvery":
      return capitalizeEveryWord(text);
    default:
      return text;
  }
};

const createT = (umiIntl, config) => {
  if (!umiIntl) {
    umiIntl = getIntl();
  }
  const t = (messageId: string, options?: TOptions) => {
    const { defaultMessage, values, nameSpace, caseType = "capitalizeEvery" } = options ?? {};
    let finalNameSpace = (nameSpace && ["all", "option"].includes(nameSpace) ? nameSpace : "all") || "all";
    if (!finalNameSpace) {
      finalNameSpace = config.defaultNameSpace;
    }
    const finalId = finalNameSpace ? `${finalNameSpace}.${messageId}` : messageId;
    const text = umiIntl.formatMessage(
      {
        id: finalId,
        defaultMessage,
      },
      values,
    );
    return handleTextCase(text, finalNameSpace === "all" ? "none" : caseType);
  };
  return t;
};

export default createT;
